const config = {
  isProd: process.env.NODE_ENV === "production",
  locale: getLocale(),
  siteName: process.env.REACT_APP_SITENAME,
  titleSuffix: process.env.REACT_APP_TITLESUFFIX,
  siteCode: process.env.REACT_APP_SITECODE,
  apiBase: process.env.REACT_APP_API_ENDPOINT,
  resourceBase: process.env.REACT_APP_RESOURCE_BASEURL,
  baseOrigin: getBaseUrl(),
  cmsEndpoint: process.env.REACT_APP_CMS_ENDPOINT,
  ver: process.env.REACT_APP_VERSION,
  updateDate: process.env.REACT_APP_UPDATED_AT,
  stripeKey: process.env.REACT_APP_STRIPE_KEY
  
  //bvClientId: process.env.REACT_APP_BAZZAR_CLIENT_ID,
  //bvSiteId: process.env.REACT_APP_BAZZAR_SITE_ID,
  //bvEnv: process.env.REACT_APP_BAZZAR_ENV,
  //bvLocale: getLocale() === 'nz' ? 'en_NZ' : 'en_AU',
}

function getLocale() {
  return process.env.REACT_APP_COUNTRY_LOCALE || getCountry()
}

function getCountry() {
  if (typeof window !== `undefined`) {
    if (window.location.hostname.toLowerCase().indexOf(".nz") >= 0) return 'nz';
    if (window.location.hostname.toLowerCase().indexOf("-nz") >= 0) return 'nz';
    if (window.location.search === '?nz=true') return 'nz';
  }
  return 'au';
}

function getBaseUrl() {
  if (typeof window !== `undefined`) {
  return window.location.origin;
  }
  return process.env.GATSBY_BASEURL;
}

console.log(process.env, config)

// Helper function to get cookie value
function getCookie(name) {
  if (typeof document === 'undefined') return null;
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) {
    const cookieValue = parts.pop().split(';').shift();
    // Return null for empty strings, otherwise return trimmed value
    return cookieValue && cookieValue.trim() ? cookieValue.trim() : null;
  }
  return null;
}

export default {
  ...config,
  getDevCartId: function() {
    if (typeof window === `undefined`) return null;
    
    // In production, read from cookie (backend sets it)
    // Cookie name format: Ecm6.CartId.{siteCode}
    if (config.isProd) {
      const cookieName = `Ecm6.CartId.${config.siteCode || 'nelsonvs'}`;
      const cartId = getCookie(cookieName);
      // Return null for empty strings or 'null' string
      return cartId && cartId !== 'null' ? cartId : null;
    }
    
    // In development, use localStorage
    const cartId = window.localStorage.getItem('cart');
    return cartId && cartId !== 'null' ? cartId : null;
  },
  setDevCartId: function(cartId) {
    if (typeof window === `undefined`) return;
    
    // In production, backend sets the cookie automatically, so we don't need to do anything
    // In development, use localStorage
    if (!config.isProd) {
      if (cartId) {
        window.localStorage.setItem('cart', cartId);
      } else {
        window.localStorage.removeItem('cart');
      }
    }
  }
}